import fetch from 'isomorphic-unfetch';

import { ApolloClient, InMemoryCache, HttpLink, ApolloLink } from '@apollo/client';

import { onError } from '@apollo/client/link/error';

import { env } from '../../common/__config__/env';

let httpLink = new HttpLink({
  uri: env.RT_CLUSTER_GRAPH,
  fetch: fetch,
  headers: {
    'x-client-id': 'privatmegleren_nybygg',
    ssr: true
  },
  credentials: 'include'
});
let errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
    });
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

let cache = new InMemoryCache();
if (typeof window !== 'undefined') {
  cache.restore(window.__APOLLO_STATE__);
}

const client = new ApolloClient({
  name: 'privatmegleren_nybygg',
  cache,
  link: ApolloLink.from([errorLink, httpLink]),
  ssrForceFetchDelay: 100
});

export { client };
